import React, {Component} from 'react';
import Loader from "../../../../components/common/Spinners/Loader";
import {selectGuestOrder, selectLanguage} from "../../../../selectors";
import {
	checkEmailVerified
} from "../../../../actions/guestOrderActions";
import {connect} from "react-redux";

class EmailConfirmation extends Component {


	componentDidMount() {
		const {newAccountInfoData, checkEmailVerified} = this.props;

		checkEmailVerified(newAccountInfoData.id);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.verificationCounter !== this.props.verificationCounter) {
			if (this.props.emailVerified === true) {
				this.props.handleChangeStep('confirmation');
			} else {
				this.props.checkEmailVerified(this.props.newAccountInfoData.id);
			}
		}
	}

	render() {
		const {handleChangeStep, values} = this.props;

		return (
			<div className="form-section" id="fs6">

				<div className="message">

					<div className="message-left">
						<i className="fas fa-envelope-open-text"></i>
					</div>

					<div className="message-right">
						<h4>Please check your inbox.</h4>
						<p>We sent you an email verification to <strong>{values.account.accountHolder.personalEmail}</strong>. Open the email and click on the link to verify your email address.</p>
					</div>

				</div>

				<Loader />

				<div className="form-group form-group-button-slim">
					<button
						type="button"
						className="btn btn-outline-secondary btn-block"
						onClick={() => handleChangeStep('customer-info')}
					>
						Change My Email
					</button>
				</div>

			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const lang = selectLanguage(state),
		emailVerified = selectGuestOrder(state).emailVerified,
		verificationCounter = selectGuestOrder(state).verificationCounter;

	return {
		emailVerified,
		verificationCounter
	};
};

const mapDispatchToProps = {
	checkEmailVerified
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfirmation);
